import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postHealthThreeStart,
  postHealthThreeSuccess,
  postHealthThreeFailure,
} from "../reducers/postHealthThreeReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postHealthThree = createAsyncThunk(
  "postHealthThree",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postHealthThreeStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Health/SaveHealthThirdPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );
      const responseData = await response;

      thunkAPI.dispatch(postHealthThreeSuccess(values));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postHealthThreeFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postHealthThreeFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postHealthThreeFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
